import "./artist_info";

import * as types from "@root/types";
import React, { FC } from "react";

import { ArtistSocial } from "../artist_social/artist_social";

interface ArtistInfoProps {
  artist: types.Artist;
}

const ArtistInfo: FC<ArtistInfoProps> = ({ artist }) => {
  if (!artist) {
    return null;
  }

  return (
    <div className="artist-info">
      <div className="artist-info--name-image">
        <div className="artist-info--name-wrapper">
          <h1 className="artist-info--name">{artist.name}</h1>
          {artist.studioNumber ? (
            <h3 className="artist-info--studio">{`Studio ${artist.studioNumber}`}</h3>
          ) : null}
        </div>
        <div className="artist-info--profile-pic">
          {/* we need this div for the grid to work */}
          {artist.profileImages.small ? (
            <img
              src={artist.profileImages.small}
              alt={`Picture of ${artist.name}`}
            />
          ) : null}
        </div>
      </div>
      <ArtistSocial artist={artist} />
    </div>
  );
};

export { ArtistInfo, ArtistInfoProps };
